<template>
    <div class="sc03_03">
        <h3><span class="tit-st"><b>구민</b>과 <b>소통</b>하는</span> 강남 브리핑</h3>
        <a :href="$_WC.cp + 'news'" class="btn-more">더보기</a>
        <div class="main_news_broadcast">
            <ul>
                <li v-for="(news, index) in videoNewsList" v-if="index < 4">
                    <a :href="$cp + 'news?tab=2&sqno=' + news.amnDataSqno">
                        <img :src="getUrl(news)" alt="video-news">
                        <p class="tit" style="margin-bottom: 0px;">{{ news.val8 }}</p>
                        <p class="cnt" style="margin-top: 0px;">{{ formatDate(news.basdtVal) }}</p>
                    </a>
                </li>
                <!--
                <li>
                    <a :href="$cp + 'news?tab=1&sqno='+latestBriefing.amnDataSqno">
                        <img :src="latestBriefing.val10" alt="brief-news" />
                        <p class="tit">{{ replaceHtmlTitle(latestBriefing.val2) }}</p>
                        <p class="cnt">{{ formatDate(latestBriefing.basdtVal) }}</p>
                    </a>
                </li>
                <li>
                    <a :href="$cp + 'news?tab=2&sqno='+latestCovidNews.amnDataSqno">
                        <img :src="getUrl(latestCovidNews)" alt="covid-news" />
                        <p class="tit">{{ replaceHtmlTitle(latestCovidNews.val10) }}</p>
                        <p class="cnt">{{ formatDate(latestCovidNews.basdtVal) }}</p>
                    </a>
                </li>
                -->
            </ul>
        </div>
    </div>
</template>

<script>
import commonConstMixin from "@/stores/common.const.mixin.js";
import gripUtil from "@/libs/grip.util";
import {$_WC, $_TYPE} from '@/confs/common.const.js';
import { mapGetters } from 'vuex';

export default {
    components: {
    },
    computed: {
        ...mapGetters({
            latestBriefing: 'getLatestBriefing',
            latestCovidNews: 'getLatestCovidNews',
            videoNewsList: 'getVideoNewsList',
        }),
    },
    created() {
    },
    methods: {
        replaceHtmlTitle(title) {
            if(typeof title !== $_TYPE.UNDEF) {
                let returnTitle = '';
                returnTitle = title.replace(/(<([^>]+)>)/ig,"");
                return returnTitle;
            }
        },
        // getUrl(news){
        //     return news.val5 !== null && news.val5 !== '' ? news.val5 : news.val9;
        // },
        getUrl(news){
            if(typeof news.val5 !== $_TYPE.UNDEF && news.val5 !== '') {
                return news.val5;
            } else {
                if(typeof news.val6 !== $_TYPE.UNDEF && news.val6 !== '') {
                    return "//www.gangnam.go.kr" + news.val6;
                }
            }
        },
        formatDate(val) {
            if(typeof val !== 'undefined' && val != '') {
                return gripUtil.formatDate(val, 'yyyy.MM.dd');
            }
        },
    },
    mixins: [commonConstMixin],
};
</script>
<style>
.main_news_broadcast ul>li p.tit{
    display: inline-block;
    width: 200px;
    white-space: nowrap;
    text-overflow: ellipsis;
}
@media (min-width: 2737px) and (max-width: 7680px) {
    .main_news_broadcast ul>li p.tit {width: 420px;}
}
@media (min-width:0px) and (max-width: 1000px) {
    .main_news_broadcast ul>li p.tit {width: 160px;}
}
</style>